import axios from "axios";

const BACKEND = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true });

export const fileUrl = (path) => {
  if (!path) return "";
  if (path.startsWith("http")) return path;
  if (path.startsWith("/api")) return `${BACKEND}${path}`;
  return path;
};

export const thumbUrl = (path) => {
  const u = fileUrl(path);
  return u && u.includes("/api/files/") ? `${u}${u.includes("?") ? "&" : "?"}thumb=1` : u;
};

export function errMsg(e) {
  const d = e?.response?.data?.detail;
  if (!d) return e?.message || "Something went wrong";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x.msg || "").join(" ");
  return String(d);
}
